import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent, ToastType } from './custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * Show a toast notification
   * @param message - The message body
   * @param type    - 'success' | 'error' | 'warning' | 'info'
   * @param title   - Optional custom title (defaults to type name)
   * @param duration - Auto-dismiss in ms (default 4000)
   * @param actionLabel - Label for action button
   * @param onAction - Callback for action button
   */
  private show(message: string, type: ToastType, title?: string, duration: number = 4000, actionLabel?: string, onAction?: () => void) {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { message, type, title, actionLabel, onAction },
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar-panel'],
    });
  }

  showSuccess(message: string, title?: string) {
    this.show(message, 'success', title);
  }

  showError(message: string, title?: string, actionLabel?: string, onAction?: () => void) {
    // If there is an action, we might want to keep it open longer or indefinitely? Let's use 8s for now.
    const duration = actionLabel ? 10000 : 5000;
    this.show(message, 'error', title, duration, actionLabel, onAction); 
  }

  showWarning(message: string, title?: string) {
    this.show(message, 'warning', title);
  }

  showInfo(message: string, title?: string) {
    this.show(message, 'info', title);
  }
}
